import { render, staticRenderFns } from "./loadingPage.vue?vue&type=template&id=571d952b&"
import script from "./loadingPage.vue?vue&type=script&lang=js&"
export * from "./loadingPage.vue?vue&type=script&lang=js&"
import style0 from "./loadingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports